// src/components/StickyNote.js
import React from 'react';
import { useDrag } from 'react-dnd';
import { ItemTypes } from '../constants/ItemTypes';

function StickyNote({ id, name, type, onMove }) {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemTypes.STICKY_NOTE,
    item: { id, name, type }, // ドラッグ中に渡すデータ
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult) {
        onMove(item.id, dropResult.areaType); // ドロップ先にアイテムが移動したことを通知
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  const opacity = isDragging ? 0.4 : 1;

  const noteStyle = {
    padding: '10px 15px',
    margin: '5px',
    backgroundColor: '#fffacd', // 付箋の色
    border: '1px solid #dcdcdc',
    borderRadius: '8px',
    cursor: 'grab',
    display: 'inline-block',
    opacity: opacity,
    boxShadow: '2px 2px 5px rgba(0,0,0,0.2)',
    fontSize: '14px',
    fontWeight: 'bold',
  };

  return (
    <div ref={drag} style={noteStyle}>
      {name}
    </div>
  );
}

export default StickyNote;